import { render, staticRenderFns } from "./UpdateMaxProduct.vue?vue&type=template&id=4de890dc"
import script from "./UpdateMaxProduct.vue?vue&type=script&lang=js"
export * from "./UpdateMaxProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports